import React from "react";

const OutPatient = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>Out-Patient Availment</h1>
      <div className='description'>
        How to avail out-patient services:
        <ul id='mainList'>
          <li className='list-item bullet'>
            Member goes to an accredited clinic (refer to list of accredited
            clinic)
          </li>
          <li className='list-item bullet'>
            Member then presents Getwell card to Medical staff for validation of
            membership
          </li>
          <li className='list-item bullet'>
            Medical staff calls Getwell to verify membership
          </li>
          <li className='list-item bullet '>
            If members status is <b>ACTIVE</b>, Getwell gives approval number
            for medical treatment.
          </li>
          <li className='list-item bullet'>
            If <b>NOT ACTIVE</b>, clinic advises member to go to his employer to
            update his membership status
          </li>
          <li className='list-item bullet'>
            For members, approved for treatment, medical staff fills up
            Outpatient Consultation Charge Slip (OCCS) and Getwell Coordinator.
          </li>
          <li className='list-item bullet'>
            Member-patients signs the Out Patient Consultation Charge Slip
            (OCCS) and avails of consultation and/or medical procedure
          </li>
        </ul>
      </div>
    </div>
  );
};

export default OutPatient;
